import type { UserTag, UserTagServer } from '@metapic-apps/shared'

export const normalizeUserTags = (
  data: Pick<UserTagServer, 'id' | 'name' | 'slug'>[],
): UserTag[] => {
  return data.map((item) => ({ id: item.id, name: item.name, slug: item.slug }))
}
